import React from "react";

// Interpolates a translated string that contains {tokens} with JSX parts:
//   rich(t("k", "Ouvre {obs} → …"), { obs: <b>OBS</b> })
export const rich = (s, parts = {}) =>
  String(s ?? "").split(/(\{\w+\})/).map((seg, i) => {
    const m = seg.match(/^\{(\w+)\}$/);
    if (!m) return seg;
    return <React.Fragment key={i}>{parts[m[1]] !== undefined ? parts[m[1]] : seg}</React.Fragment>;
  });

// Plain-text interpolation: fill("Encore {n} abonnés", { n: 3 })
export const fill = (s, vars = {}) => String(s ?? "").replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined && vars[k] !== null ? String(vars[k]) : `{${k}}`));
